var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 437.94 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 351.08,
    y1: 267.83,
    x2: 30.39,
    y2: 341.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fdde31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fccc2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f9ad2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f5832b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f04e28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec1e25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 330.51,
    y1: 128.5,
    x2: 165.44,
    y2: 498.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fee531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fabc2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f4792a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f04828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ed2926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ec1e25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 383.13,
    y1: 231.45,
    x2: 191.9,
    y2: 595.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fee531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fdda30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f9a82d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f57e2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f25b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ef4027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ed2d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ec2225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec1e25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 449.78,
    y1: 305.52,
    x2: 233.86,
    y2: 647.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fcca2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f5842b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ec1e25"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.13,0s51.5,50.5-63.5,199.5l-69,103s-108,141,12,253c0,0,82.25,63,129.13,58,0,0-49.46-42.35-68.74-118.44-.28-1.1-.7-1.92-.89-3-3.82-23.58-6.44-57.61,50.5-148.5l89-131s36-48-8-106Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.13,106s26,80-21,151c0,0-36.5,54.5-73.5,99.5,0,0-40,44-35,135,0,0,0-20,93-109,0,0,61-59,76-95C319.63,287.5,365.63,211.5,280.13,106Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.17,190.79S363,272.29,311.6,340.15c0,0-39.89,52.07-79.68,94.62,0,0-42.72,41.37-43.52,132.5,0,0,1.27-20,99.75-102.86,0,0,64.63-55,81.89-90C370,374.44,420.78,301.52,342.17,190.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M403.12,276.1S417.48,359,360.87,422.58c0,0-43.87,48.76-86.89,88.05,0,0-45.85,37.86-53.83,128.65,0,0,2.84-19.8,107.55-94.68,0,0,68.76-49.73,88.72-83.23C416.42,461.37,472.76,392.67,403.12,276.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.58,650.24H85.67v83.54h40v10.15H73.58Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M187.7,700H151.28v33.78h40.59v10.15H139.18V650.24h50.6v10.14h-38.5V690H187.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M287.64,696.11c0,32.25-19.6,49.35-43.51,49.35-24.74,0-42.12-19.19-42.12-47.54,0-29.75,18.49-49.21,43.51-49.21C271.1,648.71,287.64,668.31,287.64,696.11Zm-72.7,1.53c0,20,10.84,38,29.89,38s30-17.66,30-38.92c0-18.63-9.73-38.09-29.89-38.09S214.94,677.07,214.94,697.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M303.34,651.49a126.13,126.13,0,0,1,23.22-2c12.92,0,21.26,2.37,27.1,7.65,4.73,4.17,7.37,10.56,7.37,17.79,0,12.37-7.78,20.57-17.65,23.91v.42c7.22,2.5,11.53,9.17,13.76,18.9,3.06,13.07,5.28,22.1,7.23,25.72H351.86c-1.53-2.64-3.62-10.7-6.26-22.38-2.78-12.93-7.78-17.79-18.77-18.21H315.44v40.59h-12.1Zm12.1,42.67h12.37c12.93,0,21.13-7.09,21.13-17.79,0-12.09-8.76-17.37-21.55-17.51A49.48,49.48,0,0,0,315.44,660Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.05,780.68c-.32-6-.71-13.25-.64-18.62h-.19c-1.48,5.05-3.27,10.43-5.44,16.38l-7.62,20.93h-4.22l-7-20.55c-2.05-6.08-3.77-11.64-5-16.76h-.13c-.12,5.37-.45,12.6-.83,19.07l-1.15,18.49h-5.31l3-43.13h7.11L149,777.35c1.79,5.31,3.26,10,4.35,14.53h.19c1.09-4.35,2.63-9.09,4.55-14.53l7.67-20.86h7.11l2.69,43.13h-5.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.49,779.4H189.72V795h18.69v4.67H184.15V756.49h23.3v4.67H189.72v13.63h16.77Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.64,757.06a80,80,0,0,1,11.84-.89c8,0,13.7,1.85,17.47,5.37S251,770.06,251,777s-2.18,12.8-6.21,16.77-10.68,6.2-19.07,6.2a90,90,0,0,1-10.11-.51Zm5.57,38.15a35.91,35.91,0,0,0,5.63.32c11.9,0,18.37-6.66,18.37-18.31.06-10.17-5.7-16.64-17.47-16.64a31.59,31.59,0,0,0-6.53.58Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.83,756.49v43.13h-5.57V756.49Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.54,786.05l-4.48,13.57H270.3L285,756.49h6.72l14.72,43.13h-5.95l-4.61-13.57Zm14.14-4.35-4.22-12.41c-1-2.82-1.61-5.38-2.24-7.87h-.13c-.64,2.56-1.35,5.18-2.18,7.8l-4.22,12.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeorLogo);
export default __webpack_public_path__ + "static/media/leor_logo.4295f26059ee03f6707228fa4638a48e.svg";
export { ForwardRef as ReactComponent };